import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TelephonePipe } from './telephone.pipe';
import { TitleCasePipe } from './title-case.pipe';
import { YesNoBoolean } from './yes-no-boolean.pipe';
import { TimeHhMmSsPipe } from "./time-hh-mm-ss.pipe";
import { YesNoString } from './yes-no-string.pipe';
import { CommonModule } from '@angular/common';
import {EinPipe} from "./efast/ein.pipe";

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
        TimeHhMmSsPipe,
		TelephonePipe,
		TitleCasePipe,
		YesNoBoolean,
        YesNoString,
		EinPipe

	],
	exports: [
		TelephonePipe,
		TitleCasePipe,
		YesNoBoolean,
        YesNoString,
		EinPipe
	],
    providers: [
        DatePipe,
        TimeHhMmSsPipe
    ]
})
export class GdPipesModule { }
